import { PatientNote, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { dateFormatter } from '@dreryk/react-common';

import { EditNoteModal, RemoveNote } from '~legacy.patient';

import { StyledNotesListItemHeader } from './StyledNotesListItemHeader';

type NotesListItemHeaderProps = { readonly patientId: PatientSimple['id'] } & PatientNote;

const NotesListItemHeader = (props: NotesListItemHeaderProps): JSX.Element => {
   return (
      <StyledNotesListItemHeader>
         <span>{dateFormatter(props.lastModificationDate)}</span>
         <div>
            <EditNoteModal
               patientId={props.patientId}
               content={props.content}
               id={props.id}
               createdBy={props.createdBy}
            />
            <RemoveNote patientId={props.patientId} id={props.id} />
         </div>
      </StyledNotesListItemHeader>
   );
};

export { NotesListItemHeader };
